import Vue from "vue";
import { zGuestFormOtherInfo } from "zoox-components";
import {
  ReservationService,
  CompanyService,
  FieldsService,
  CompanyFilterService,
  validationMixin
} from "smck-service";
import { FlashMessageService } from "zoox-infra";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import ReservationDataHeader from "@/components/shared/ReservationDataHeader";
import { mapActions } from "vuex";

export default {
  name: "GuestOtherInfo",
  mixins: [validationMixin, sessionMixin],
  components: {
    "z-guest-form-other-info": zGuestFormOtherInfo,
    ReservationDataHeader
  },
  props: [
    "activeTab",
    "reservation",
    "emailNotRequired",
    "jobNotRequired",
    "fieldSettingsData"
  ],
  data() {
    return {
      isActive: false,
      companyId: "",
      companyName: "",
      reservationService: new ReservationService(Vue),
      fieldsService: new FieldsService(Vue),
      companyService: new CompanyService(Vue),
      companyFilterService: new CompanyFilterService(),
      companyParams: null,
      additionalData: null,
      navigating: false,
      isLoading: false,
      fillByPerson: false,
      hasBeenSaved: false,
      currentRes: this.reservation
    };
  },
  watch: {
    reservation() {
      this.currentRes = this.reservation;
    }
  },
  computed: {
    guestId() {
      return this.$route.params.guestId;
    },
    reservationId() {
      return this.$route.params.reservationId;
    },
    paramsReady() {
      return ["fieldSettingsData", "companyParams", "additionalData"].reduce(
        (acc, data) => acc && this[data] !== null,
        true
      );
    }
  },
  mounted() {
    Vue.$globalEvent.$emit("guestOtherInfoSaved");

    this.$_gtagPlugin_trackEvent("ENTERED_GUEST_FORM_OTHER_INFO", "PORTAL");
    const $context = this;

    const company = $context.companyService.getLocalCompany(true);

    $context.companyId = company.id;
    $context.companyName = company.name;

    $context.fieldsService.getAdditionalData($context.companyId).then(resp => {
      $context.additionalData = resp;
    });

    $context.companyService
      .getFnrhFormSettings($context.companyId)
      .then(resp => {
        $context.companyParams = resp;
      });

    // if ($context.currentPersonId) {
    //   $context
    //     .$autoFill(
    //       $context.$route.params.reservationId,
    //       $context.currentPersonId,
    //       $context.currentPhoto,
    //       true
    //     )
    //     .then(() => {
    //       $context.fillByPerson = true;
    //       return $context.getReservation(
    //         $context.$route.params.reservationId,
    //         $context.$route.params.guestId
    //       );
    //     });
    // } else {
    $context.getReservation(
      $context.$route.params.reservationId,
      $context.$route.params.guestId
    );
    // }

    setTimeout(() => {
      $("input,select").each(function(i) {
        if ($context.type !== "hidden") {
          const $input = $(this);
          const strAux = `${new Date().getTime()}-${i}`;
          const name = $input.attr("name") || "";
          $input.attr("name", `${name}-${strAux}`);
          $input.attr("tabindex", i + 1);
          $input.attr("autocomplete", `no-autocomplete-${strAux}`);
        }
      });
    }, 1500);
    //chama a validação do campo outras informações no mobile
    // if ($context.isMobile) {
    //   $context.callValidation();
    // }
  },
  methods: Object.assign(
    {
      getReservation: async function(reservationId) {
        const $context = this;

        const autofillData = $context.reservationService.getLocalReservation();
        if (reservationId !== autofillData.id) {
          $context.reservation = await $context.reservationService.getOne(
            reservationId
          );
        }

        const guestDocumentData =
          $context.guestDocumentData[$context.guestId] || {};

        const masterGuest = $context.reservation.guests.find(
          g => g.masterGuest
        );
        const emailPool = [masterGuest.email];
        $context.reservation.guests = $context.reservation.guests.map(
          (guest, index) => {
            if (guest.id === $context.guestId) {
              if (guest.fnrhId) {
                $context.$router.push({ name: "Success" });
              }

              $context.fillByPerson = guest.documentNumber ? true : false;

              let email =
                $context.reservation.guests[index].ota !== "N/A"
                  ? $context.reservation.guests[index].email
                  : guest.email;

              let newGuest = Object.assign(
                {},
                $context.reservation.guests[index],
                guest,
                {
                  documentTypeId:
                    typeof guest.documentTypeId === "number"
                      ? guest.documentTypeId
                      : guestDocumentData.documentTypeId,
                  documentNumber:
                    guest.documentNumber || guestDocumentData.documentNumber,
                  email:
                    !guest.masterGuest && emailPool.indexOf(email) > -1
                      ? ""
                      : email
                }
              );

              if (newGuest.email) {
                emailPool.push(email);
              }

              return newGuest;
            }
            return guest;
          }
        );
        $context.$setCurrentReservation($context.reservation);
        // });
      },
      emitErrorForUser() {
        FlashMessageService.clear();
        FlashMessageService.error(this.$t("GUEST_FORM.FILL_REQUIRED_FIELDS"));
      },
      successHandler: function(resp) {
        const {
          useTerms,
          privacyTerms,
          mediaTerms,
          qualificationDataTerms,
          emailTerms
        } = this.$store.state;
        // go to documents tab!
        if (this.$customization && this.$customization.enableDocumentScan) {
          this.$emit("tabChange", 2);
        } else {
          this.$setCurrentMobileStep(2);
        }
        this.hasBeenSaved = true;
        if (!this.navigating && resp && resp.reservation && resp.guest) {
          this.$_gtagPlugin_trackEvent(
            "SAVED_GUEST_FORM",
            "PORTAL",
            this.guestId
          );
          this.navigating = true;
          // this.reservationService.setLocalReservation({});
          FlashMessageService.success(
            this.$root.$t("GLOBAL.SUCCESS_UPDATE_MESSAGE")
          );

          const res = this.reservationService.updateLocalGuest(this.guestId, {
            terms: {
              useTerms,
              privacyTerms,
              mediaTerms,
              qualificationDataTerms,
              emailTerms
            }
          });
          this.$setCurrentGuest(resp.guest);
          this.$setCurrentReservation(res);
        }

        this.navigating = false;
      },
      failHandler: function() {
        // maintain other info tab
        this.$emit("tabChange", 1);
      },
      resetValidation: function() {
        const $context = this;
        setTimeout(() => {
          if (
            $context.$refs &&
            $context.$refs.otherInfo &&
            $context.$refs.otherInfo.$refs &&
            $context.$refs.otherInfo.$refs.guestFormOtherInfo
          ) {
            $context.$refs.guestForm.$refs.guestForm.resetValidation();
          }
        }, 500);
      },
      callValidation() {
        const $context = this;

        setTimeout(() => {
          if (
            $context.$refs &&
            $context.$refs.otherInfo &&
            $context.$refs.otherInfo.$refs &&
            $context.$refs.otherInfo.$refs.guestFormOtherInfo
          ) {
            $context.$refs.otherInfo.$refs.guestFormOtherInfo.validate();
          }
        }, 500);
      },
      goBack() {
        Vue.$globalEvent.$emit("tabChange", 0);
        this.$setIsBackingStep(true);
      }
    },
    mapActions(["$setIsBackingStep"])
  )
};
